/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ShortName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Simple/Data/validate.js'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function ShortName({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsCardWrite/ShortName",
  onChange,
  isSubmitting,
  isValid,
  isInvalid
  
}) {
let txCardFieldDefinitionShortNameValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_field_definition',
path: 'short_name',
})
let txCardFieldDefinitionShortNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'tx_card_field_definition',
path: 'short_name',
validate: fromValidate.textAtLeastOneChar,
})
let txCardFieldDefinitionShortNameChangeData = fromData.useDataChange({ viewPath,
context: 'tx_card_field_definition',
path: 'short_name',
})
let txCardFieldDefinitionShortNameIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'tx_card_field_definition',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 label="Short Name"
 data="tx_card_field_definition.short_name"
 value={txCardFieldDefinitionShortNameValueData}
 onChange={txCardFieldDefinitionShortNameChangeData}
 disabled={txCardFieldDefinitionShortNameIsSubmittingData}
 validate="/Simple/Data/validate.js textAtLeastOneChar"
 valid={txCardFieldDefinitionShortNameIsValidData}
 invalid={!txCardFieldDefinitionShortNameIsValidData}
/>
{children}
</React.Fragment>)
}